<input data-testid="page-size-input" #inputElement type="number" mdbInput id="pageSize" name="pageSize" class="form-control form-control-sm page-size-input" [ngModel]="pageSize" [min]="min"
  [max]="max">
